// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"803d6e28","453":"e2c1fef2","455":"6177e698","977":"2eef2bd3"}[chunkId] + ".chunk.js";
};